<section class="ecus-dialog" [class.missing]="data.type === 'missing'" [attr.aria-busy]="isLoading()">
  <header>
    <div><h2 id="top-ecus-dialog-title">{{ title }}</h2><p>ECU builds ordered by highest count</p></div>
    <button type="button" class="close-button" (click)="dialogRef.close()" aria-label="Close ECU list"><i class="bi bi-x-lg" aria-hidden="true"></i></button>
  </header>
  <div class="list-viewport" tabindex="0" aria-label="ECU rankings, scroll to load more" infinite-scroll
       [scrollWindow]="false" [infiniteScrollDistance]="2" [infiniteScrollThrottle]="150"
       [infiniteScrollDisabled]="isLoading() || !hasMore() || !!error()" (scrolled)="onScroll()">
    <table>
      <thead><tr><th scope="col">ECU build</th><th scope="col" class="bar-column"><span class="visually-hidden">Relative count</span></th><th scope="col" class="count-column">Count</th></tr></thead>
      <tbody>
      @for (row of rows(); track row.ecuBuild) {
        <tr><td class="ecu-name" [title]="row.ecuBuild">@if (row.ecuBuild != null) {<a [routerLink]="['/app/requested-tunings/requested-tunings-tables']" [queryParams]="{type: data.type, ecuBuild: row.ecuBuild, source: 'dashboard'}" (click)="dialogRef.close()">{{ row.ecuBuild || '(Empty value)' }}</a>} @else {Unknown ECU build}</td>
          <td class="bar-column"><div class="ecu-bar" aria-hidden="true"><div class="ecu-bar-fill" [style.width.%]="row.barPct"></div></div></td>
          <td class="count-column">{{ row.count | number }}</td></tr>
      }
      </tbody>
    </table>
    @if (isLoading()) {
      <div class="list-state" role="status">Loading ECU builds…</div>
    } @else if (error()) {
      <div class="list-state" role="alert">{{ error() }}<button type="button" (click)="retry()">Retry</button></div>
    } @else if (!rows().length) {
      <div class="list-state">Nothing to show.</div>
    }
  </div>
</section>
